export const DISPLAY = {
  MOBILE_VERTICAL_MAX: '480px',
  TABLET_VERTICAL_MAX: '767px',
  TABLET_HORIZONTAL_MAX: '1023px',
};

export const LAYER = {
  HEADER: 100,
  SCROLL_FLOATING_BUTTON: 50,
  BODY_SIDE_PANEL: 50,
};
